import React, {useEffect, useRef, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toastify/dist/ReactToastify.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import {toast, ToastContainer} from 'react-toastify';
import {
    base64ToByteArray,
    base64ToUtf8,
    createFile,
    downloadFile,
    formatDateForMailDisplay
} from "../utils/utils";
import Navigation from "../components/navigation";
import Header from "../components/header";
import {useNavigation} from "../hooks/navigation"
import StandardTextInput from "../components/basic/StandardTextInput";

import Styles from "../styles/main.module.css";

import {
    copyMessageOnServer, moveMessageOnServer, deleteMessageOnServer,
    fetchAttachmentData, fetchHeadersOfMessage,
    fetchMessageBody,
    fetchThreadByThreadId, fetchUserAccounts,
    listBoxes,
    listing,
    listingForCache, markMessageOnServer
} from "../server-calls/index"
import StateManager from "../redux/StateManager";
import {
    CACHE_CONF,
    HTML_MESSAGE_IDENTIFIER,
    SORT_OPTIONS,
    SORT_ORDER, TRASH_BOX
} from "../utils/constants";
import _ from "lodash";
import StandardDropdown from "../components/basic/StandardDropDown";
import {decryptPGPMessage} from "../business/encryption/pgp";
import {
    addBoxesListInCache, copyMessageInCache, deleteMailsCacheDB, deleteMessagesFromCache,
    fetchThreadFromCache, fetchUserAccountsFromCache, getLastUidOfBox,
    getSearchPaginatedResults,
    initMailsCacheDB, listMessagesFromCache,
    listUserVisibleBoxesFromCache, listUserVisibleBoxesFromCacheWithUnreadCount, markMessageInCache, moveMessageInCache,
    parseAndAddEmailInCache,
    readMessageByUid, saveAccountInCache,
    updateCache
} from "../idb";
import md5 from "md5";
import {Helmet} from "react-helmet-async"
import {
    createSubstring,
    decodeIfMimeEncoded,
    decryptMessageAttachmentNames,
    decryptMessageBody,
    decryptMessageSubject, extractEmail
} from "../mail/utils";
import StandardButton from "../components/basic/StandardButton";
import Modal from "react-modal";
import StandardIconDropDown from "../components/basic/StandardIconDropDown/StandardIconDropdown";
import PaginationWithInput from "../components/basic/Pagination";

export default function Mail() {
    const TOAST_CONTAINER_ID = "mail-toast-container"
    const navigationRef = useRef();

    const startSocketHandler = () => {
        if (StateManager.isCacheComplete())
            navigationRef.current?.handleSocket();
    };

    const headerModalStyles = {
        content: {
            width: "auto",
            height: "70%",
            margin: "auto",
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            overflow: "scroll"
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        }
    };

    const deleteConfirmationStyles = {
        content: {
            width: "35%",
            height: "20%",
            margin: "auto",
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            overflow: "hidden"
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        }
    };

    const {redirect, reloadPage} = useNavigation()
    let [mailData, setMailData] = useState([]);
    let [mailboxes, setMailboxes] = useState([]);
    let [dropDownBoxes, setDropDownBoxes] = useState([]);
    const dropDownReadUnread = [{
        value: "Seen",
        text: "Read"
    }, {
        value: "Recent",
        text: "UnRead"
    }]
    let [sortOptions] = useState(SORT_OPTIONS)
    let [sortKey, setSortKey] = useState(StateManager.getMailSortingKey())
    let [sortOrders] = useState(SORT_ORDER)
    let [sortOrder, setSortOrder] = useState(StateManager.getMailSortingOrder())
    let [currentMbox, setCurrentMailbox] = useState(StateManager.getCurrentMbox())
    let [currentPage, setCurrentPage] = useState(1)
    let [totalPages, setTotalPages] = useState(1)
    let [hasNextPage, setHasNextPage] = useState(false)
    let [totalMessages, setTotalMessages] = useState(0)
    let [hasPreviousPage, setHasPreviousPage] = useState(false)
    let [pageSize] = useState(7)
    let [currentMsg, setCurrentMsg] = useState({})
    let [cacheStarted] = useState(false)
    let [searchValue, setSearchValue] = useState("")
    let [isSingleMessageRender, setIsSingleMessageRender] = useState(false)
    let searchButtonRef = useRef()
    let [isModalOpen, setIsModalOpen] = useState(false)
    let [modalContent, setModalContent] = useState("")
    let [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false)
    let [deletePayload, setDeletePayload] = useState({})
    let [userAccounts, setUserAccounts] = useState([])
    let [selectedUserAccount, setSelectedUserAccount] = useState()
    let [selectionEnabled] = useState(true)
    let [selectedUids, setSelectedUids] = useState([])
    let [selectedThreadIds, setSelectedThreadIds] = useState([])
    let [isThreadRendered, setIsThreadRendered] = useState(false)
    let [fullThread, setFullThread] = useState([])
    const [expandedMessages, setExpandedMessages] = useState([]);
    const [renderedRecordUid, setRenderedRecordUid] = useState(0);

    const toggleMessageExpansion = (key) => {
        setExpandedMessages(prev =>
            prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
        );
    };

    const emptyExpansionToggledMessages = () => {
        setExpandedMessages([])
    }

    function stateUpdateSelectedUserAccount(value) {
        selectedUserAccount = value
        setSelectedUserAccount(selectedUserAccount)
    }

    async function setupLocalCacheDbAndReturnBoxes() {
        if (!StateManager.isCacheDbSetupComplete()) {
            console.log(`DB setup is not complete yet, setting up`)
            await deleteMailsCacheDB()
            let [serverBoxes, userAccounts] = await Promise.all([listBoxes(StateManager.getToken()), fetchUserAccounts(StateManager.getToken())])
            await initMailsCacheDB(serverBoxes)
            await addBoxesListInCache(serverBoxes)
            await saveAccountInCache(userAccounts)
            StateManager.setIsCacheDbSetupComplete(true)
        } else {
            console.log(`DB setup is complete`)
        }
        if (!StateManager.isCacheComplete()) {
            console.log(`Cache is not complete yet, setting up`)
            startCache()
        } else {
            startSocketHandler()
            console.log(`Cache is complete`)
        }
    }

    async function startCache() {
        let mailboxes = await listUserVisibleBoxesFromCache()
        let body = CACHE_CONF
        for (let i = 0; i < mailboxes.length; i++) {
            let lastId = await getLastUidOfBox(mailboxes[i].name)
            console.log(lastId)
            body.box = mailboxes[i].name
            let currentMailboxDone = false
            while (!currentMailboxDone) {
                try {
                    body.lastId = lastId
                    let mailData = await listingForCache(body, StateManager.getToken())
                    if (_.isEmpty(mailData.mails)) {
                        currentMailboxDone = true
                        break;
                    }
                    let mails = mailData.mails
                    for (let j = 0; j < mails.length; j++) {
                        let mailObject = mails[j]
                        await parseAndAddEmailInCache(mailboxes[i].name, mailObject)
                        if (j === mails.length - 1) {
                            lastId = mails[j].uid
                        }
                    }
                    if (mails.length < CACHE_CONF.setSize) {
                        currentMailboxDone = true
                        break;
                    }
                } catch (e) {
                    currentMailboxDone = true
                    break;
                }
            }
            console.log(`Cache done for ${mailboxes[i].name}`)
        }

        StateManager.setIsCacheComplete(true)
        console.log(`All Done, for cache`)
        toast.dismiss({containerId: TOAST_CONTAINER_ID})
        toast.success(`System cache is complete now.`, {containerId: TOAST_CONTAINER_ID})
        startSocketHandler()
    }

    function isListingRenderNeeded(message) {
        if (message.eventType === "newMessage") {
            return message.message.box === currentMbox && StateManager.getMailSortingOrder() === "descending" && StateManager.getMailSortingKey() === "date"
        } else if (message.eventType === "boxDeleted") {
            if (message.message.name === currentMbox) {
                stateUpdateCurrentMailbox("INBOX")
            } else {
                return true
            }
        } else {
            return message.eventType === "messageMoved" || message.eventType === "messageDeleted" || message.eventType === "boxCreated"
        }
    }


    function stateUpdateCurrentMsg(data) {
        currentMsg = data
        setCurrentMsg(currentMsg)
    }


    function stateUpdateHasNextPage(value) {
        hasNextPage = value
        setHasNextPage(hasNextPage)
    }

    function stateUpdateHasPreviousPage(value) {
        hasPreviousPage = value
        setHasPreviousPage(hasPreviousPage)
    }

    function stateUpdateCurrentPage(value) {
        currentPage = value;
        setCurrentPage(currentPage);
    }

    function stateUpdateTotalPages(value) {
        totalPages = value
        setTotalPages(totalPages)
    }

    function stateUpdateSortOption(event) {
        const value = event.target.value
        StateManager.setMailSortingKey(value)
        sortKey = value
        setSortKey(sortKey)
    }

    function stateUpdateSortOrder(event) {
        const value = event.target.value
        StateManager.setMailSortingOrder(value)
        sortOrder = value
        setSortOrder(sortOrder)
    }

    function stateUpdateMailData(data) {
        mailData = data
        setMailData(data);
    }

    function stateUpdateCurrentMailbox(value) {
        currentMbox = value
        setCurrentMailbox(currentMbox)
        StateManager.setCurrentMbox(currentMbox)
        setIsThreadRendered(false)
        setIsSingleMessageRender(false)
    }

    function stateUpdateMailBoxes(value) {
        mailboxes = value
        setMailboxes(mailboxes)

        let dropDownBoxes = []
        mailboxes.forEach((box) => {
            if (box.name !== currentMbox) {
                dropDownBoxes.push({
                    value: box.name,
                    text: box.name
                })
            }
        })

        setDropDownBoxes(dropDownBoxes)
    }

    async function startingOperations() {
        let userAccounts
        if (StateManager.isCacheDbSetupComplete()) {
            userAccounts = await fetchUserAccountsFromCache()
        } else {
            userAccounts = await fetchUserAccounts(StateManager.getToken())
        }
        let cleaned = [{value: "all", text: "All"}]
        userAccounts.forEach((account) => {
            cleaned.push({value: account.email, text: account.email})
        })
        stateUpdateSelectedUserAccount(StateManager.getMailListingAccount())
        setUserAccounts(cleaned)
        await setupLocalCacheDbAndReturnBoxes()
        await renderListingAndBoxes()
        setCurrentMsg({})
    }

    async function renderListingAndBoxes() {
        return Promise.all([renderBoxes(), renderListing()])
    }

    async function renderBoxes() {
        let boxes
        if (StateManager.isCacheDbSetupComplete()) {
            boxes = await listUserVisibleBoxesFromCacheWithUnreadCount(selectedUserAccount === "" ? "all" : selectedUserAccount)
        } else {
            boxes = await listBoxes(StateManager.getToken())
        }
        stateUpdateMailBoxes(boxes)
    }


    async function changeAccount(e) {
        let value = e.target.value
        StateManager.setMailListingAccount(value)
        await renderListing(true)
    }

    const renderListing = async (showLoader = false, message = "loading listing") => {
        clearSelection()
        if (showLoader)
            toast.loading(message, {containerId: TOAST_CONTAINER_ID})
        let mailData
        if (StateManager.getIsSearchRecordRender()) {
            mailData = await getSearchPaginatedResults(currentMbox, StateManager.getSearchEncryptedWords(), StateManager.getSearchCurrentPage(), pageSize)
            handleSearchValue(StateManager.getSearchPlainText())
            searchButtonRef.current.innerText = "Clear"
        } else {
            if (StateManager.isCacheDbSetupComplete() && StateManager.isCacheComplete()) {
                mailData = await listMessagesFromCache(currentMbox, currentPage, pageSize, StateManager.getMailSortingKey(), StateManager.getMailSortingOrder() === "ascending", StateManager.getMailListingAccount());
            } else {
                mailData = await listing(StateManager.getToken(), {
                    box: currentMbox,
                    pageSize: pageSize,
                    pageNumber: currentPage,
                    sortOption: StateManager.getMailSortingKey(),
                    ascending: StateManager.getMailSortingOrder() === "ascending",
                    intendedFor: selectedUserAccount === "" ? "all" : selectedUserAccount
                });
            }
        }

        if (!_.isEmpty(mailData.mails)) {
            const mails = await decryptSubjects(mailData.mails);
            stateUpdateMailData(mails);
            stateUpdateTotalPages(mailData.totalPages);
            setTotalMessages(mailData.totalPages * pageSize)
            stateUpdateCurrentPage(mailData.pageNumber);
            stateUpdateHasNextPage(mailData.hasNext);
            stateUpdateHasPreviousPage(mailData.hasPrevious);
        } else {
            stateUpdateMailData([]);
        }
        if (showLoader)
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
    }

    useEffect(() => {
        toast.promise(startingOperations(), {
            pending: "loading mails",
            error: "some error occurred"
        }, {
            containerId: TOAST_CONTAINER_ID
        }).catch(e => {
            console.error(e)
        })
    }, [currentMbox, currentPage, sortKey, sortOrder]);

    function handleSearchValue(value) {
        searchValue = value
        setSearchValue(searchValue)
    }

    async function stateUpdateSearch() {
        if (!StateManager.isCacheComplete() || !StateManager.isCacheDbSetupComplete()) {
            toast.error(`Cache is not complete yet, please wait for it to complete.`, {containerId: TOAST_CONTAINER_ID})
            return
        }
        if (StateManager.getIsSearchRecordRender()) {
            StateManager.setIsSearchRecordRenderInState(false)
            StateManager.setSearchPlainTextInState("")
            StateManager.setSearchEncryptedWordsInState([])
            StateManager.setSearchCurrentPageInState(1)
            searchButtonRef.current.innerText = "Search"
            reloadPage()
            searchValue = ""

        }
        searchButtonRef.current.innerText = "Clear"
        if (_.isEmpty(searchValue)) {
            return
        }
        let words = []
        if (searchValue.includes(" ")) {
            words = searchValue.split(" ")
        } else {
            words = [searchValue]
        }
        let encryptedWords = []
        words.forEach((word) => {
            encryptedWords.push(md5(word))
        })
        StateManager.setSearchPlainTextInState(searchValue)
        StateManager.setSearchEncryptedWordsInState(encryptedWords)
        StateManager.setIsSearchRecordRenderInState(true)
        StateManager.setSearchCurrentPageInState(1)
        await renderListing(true, "searching...")
    }

    async function decryptSubjects(mails) {
        for (let i = 0; i < mails.length; i++) {
            mails[i].decryptedSubject = decodeIfMimeEncoded(await decryptMessageSubject(mails[i]))
            mails[i].formattedDate = formatDateForMailDisplay(mails[i].date)
        }
        return mails
    }

    async function renderMessage(key) {
        console.log(`rendering message: ${key}`)
        let mail = mailData[key]
        if (mail.uid === currentMsg.uid) {
            return
        }

        try {
            emptyRenderedStuff()
            toast.loading("Rendering message", {containerId: TOAST_CONTAINER_ID})
            setRenderedRecordUid(mail.uid)
            if (mail.threadSize > 1) {
                return renderThread(mail)
            }
            await markMessageAsRead(mailData[key])
            let messageData = await readMessageByUid(currentMbox, mail.uid)
            if (_.isEmpty(messageData)) {
                messageData = await fetchMessageBody(mail.uid, currentMbox, StateManager.getToken())
            }

            let [body, attachmentNames] = await Promise.all([
                decryptMessageBody(messageData),
                decryptMessageAttachmentNames(messageData)
            ])

            if (!body.startsWith(HTML_MESSAGE_IDENTIFIER)) {
                body = `<p>${body}</p>`
            } else {
                let html = body.split(HTML_MESSAGE_IDENTIFIER)[1]
                body = base64ToUtf8(html)
            }
            mail.formattedDate = formatDateForMailDisplay(mail.date)
            mail.decryptedBody = body
            mail.decryptedAttachmentNames = attachmentNames

            console.log(mail.decryptedAttachmentNames)

            let attachments = attachmentNames.split("/")
            let newAttachments = []

            if (!_.isEmpty(attachmentNames)) {
                newAttachments = attachments.filter(item => item !== "")
            }


            mail.parsedAttachmentNames = newAttachments

            stateUpdateCurrentMsg(mail)

            setIsThreadRendered(false)
            setFullThread([])
            setIsSingleMessageRender(true)

            toast.dismiss({containerId: TOAST_CONTAINER_ID})
        } catch (e) {
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.error(`Error rendering message`)
        }
    }


    function markThreadAsIsRead(threads) {
        let markReadRequired = false
        for (let i = 0; i < threads.length; i++) {
            let thread = threads[i]
            if (thread.flags.includes("Recent")) {
                markReadRequired = true
                thread.flags[thread.flags.indexOf("Recent")] = "Seen"
            }
        }
        if (markReadRequired) {
            return markMessageMainOperation("thread", currentMbox, "Seen", [], [threads[0].threadId])
        }
    }

    function emptyRenderedStuff() {
        setIsThreadRendered(false)
        setIsSingleMessageRender(false)
        emptyExpansionToggledMessages()
        setCurrentMsg({})
        setFullThread([])
    }

    async function renderThread(mail) {
        const {threadId, uid} = mail
        let threads
        if (StateManager.isCacheComplete()) {
            threads = await fetchThreadFromCache(threadId, currentMbox)
        } else {
            threads = await fetchThreadByThreadId(StateManager.getToken(), {threadId, box: currentMbox})
        }
        if (mailItemIsAThread(mail))
            await markThreadAsIsRead(threads)
        else
            await markMessageAsRead(mail)
        let promises = []
        threads.forEach((thread) => {
            promises.push(Promise.all([
                decryptMessageSubject(thread),
                decryptMessageBody(thread),
                decryptMessageAttachmentNames(thread)
            ]))
        })

        let decryptedThreads = await Promise.all(promises)

        for (let i = 0; i < decryptedThreads.length; i++) {
            let [subject, body, attachmentNames] = decryptedThreads[i]

            if (threads[i].isEncrypted) {
                if (!body.startsWith(HTML_MESSAGE_IDENTIFIER)) {
                    body = `<p>${body}</p>`
                } else {
                    let html = body.split(HTML_MESSAGE_IDENTIFIER)[1]
                    body = base64ToUtf8(html)
                }
            } else {
                if (!threads[i].isHtml) {
                    body = `<p>${body}</p>`
                }
            }

            threads[i].formattedDate = formatDateForMailDisplay(threads[i].date)
            threads[i].decryptedBody = body
            threads[i].decryptedSubject = subject
            threads[i].decryptedAttachmentNames = attachmentNames

            let attachments = threads[i].decryptedAttachmentNames.split("/")
            let newAttachments = []
            if (!_.isEmpty(attachmentNames)) {
                newAttachments = attachments.filter(item => item !== "")
            }


            threads[i].parsedAttachmentNames = newAttachments
        }
        setIsThreadRendered(true)
        setFullThread(threads)
        let initiatorIndex = threads.findIndex((item) => item.uid === uid)
        toggleMessageExpansion(initiatorIndex)
        toast.dismiss({containerId: TOAST_CONTAINER_ID})
    }

    function countThreadSize(thread) {
        return thread.threadSize
    }


    async function downloadAttachment(attachmentName, box, uid, isEncrypted = true) {
        toast.loading(`downloading attachment`, {containerId: TOAST_CONTAINER_ID})
        let attachmentData = await fetchAttachmentData(StateManager.getToken(), {
            attachmentName,
            box,
            uid,
            isEncrypted
        })
        console.log(attachmentData.attachmentData)
        console.log(StateManager.getPrivateKey())
        let decrypted = ""
        if (isEncrypted) {
            decrypted = await decryptPGPMessage(StateManager.getPrivateKey(), StateManager.getPassphrase(), attachmentData.attachmentData)
            console.log(decrypted)
            await downloadEncryptedAttachment(decrypted, attachmentName)
        } else {
            console.log(attachmentData.plainAttachmentData)
            await downloadPlainAttachment(attachmentData.plainAttachmentData, attachmentName)
        }
        toast.dismiss({containerId: TOAST_CONTAINER_ID})
    }

    const downloadEncryptedAttachment = (attachmentData, defaultName = "attachment.bin") => {
        if (!attachmentData) {
            console.error("No attachment data provided.");
            return;
        }


        const [rawHeaders, ...bodyParts] = attachmentData.split(/\r?\n\r?\n/);
        const base64Data = bodyParts.join("\n\n").trim();

        const headers = {};
        rawHeaders.split(/\r?\n/).forEach(line => {
            const [key, ...rest] = line.split(":");
            if (key && rest.length > 0) {
                headers[key.trim().toLowerCase()] = rest.join(":").trim();
            }
        });

        let contentType = headers['content-type'] || 'application/octet-stream';
        let fileName = defaultName;

        if (headers['content-type']) {
            const match = headers['content-type'].match(/name="?([^";]+)"?/i);
            if (match) fileName = match[1];
        }

        if (headers['content-disposition']) {
            const match = headers['content-disposition'].match(/filename="?([^";]+)"?/i);
            if (match) fileName = match[1];
        }

        console.log(`Trying to download attachment`)
        console.log(fileName)
        console.log(contentType)
        console.log(base64Data)

        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], {type: contentType});
        const blobUrl = window.URL.createObjectURL(blob);
        downloadFile(blobUrl, fileName);
    };


    const downloadPlainAttachment = (attachmentData, attachmentName) => {
        let attachmentHeaders = attachmentData.headers
        let attachmentBase64 = attachmentData.data
        let contentTypePart = attachmentHeaders["Content-Type"]
        let contentType = contentTypePart.split(";")[0]

        console.log(`Trying to download attachment`)
        console.log(attachmentName)
        console.log(contentType)
        console.log(attachmentBase64)

        let byteArray = base64ToByteArray(attachmentBase64)
        let file = createFile([byteArray], contentType)
        downloadFile(file, attachmentName)
    }


    function reply(currentMsg) {
        StateManager.setRenderedMailData(currentMsg)
        redirect("/compose?isReply=true");
    }

    function replyAll(currentMsg) {
        StateManager.setRenderedMailData(currentMsg)
        redirect("/compose?isReplyAll=true");
    }

    function forward(currentMsg) {
        StateManager.setRenderedMailData(currentMsg)
        redirect("/compose?isForward=true");
    }

    async function markMessageAsRead(mailData) {
        if (mailData.flags.includes("Recent")) {
            mailData.flags[mailData.flags.indexOf("Recent")] = "Seen";
            return markMessageMainOperation("single", currentMbox, "Seen", [mailData.uid], [])
        }
    }

    async function showHeaders(uid) {
        toast.loading("fetching headers", {containerId: TOAST_CONTAINER_ID})
        let headers = await fetchHeadersOfMessage(StateManager.getToken(), {uid, box: currentMbox})
        setModalContent(headers)
        setIsModalOpen(true)
        toast.dismiss({containerId: TOAST_CONTAINER_ID})
    }

    async function closeHeaders() {
        setIsModalOpen(false)
        setModalContent("")
    }

    function closeDeleteConfirmationModal() {
        setIsDeleteConfirmationOpen(false)
    }

    let [selectionDropdownValue, setSelectionDropdownValue] = useState("select");

    function clearSelection() {
        setSelectedUids([]);
        setSelectedThreadIds([])
        setSelectionDropdownValue("select")
    }

    function handleSelectionChange(e) {
        const value = e.target.value;
        clearSelection()
        setSelectionDropdownValue(value);
        switch (value) {
            case "all":
                selectAllRecords();
                break;
            case "unread":
                selectUnReadRecords();
                break;
            default:
                break;
        }
    }

    function selectAllRecords() {
        const newUids = [];
        const newThreadIds = [];

        mailData.forEach((mail) => {
            if (mailItemIsAThread(mail)) {
                newThreadIds.push(mail.threadId);
            } else {
                newUids.push(mail.uid);
            }
        });

        setSelectedUids((prev) => [
            ...prev,
            ...newUids.filter((uid) => !prev.includes(uid)),
        ]);

        setSelectedThreadIds((prev) => [
            ...prev,
            ...newThreadIds.filter((id) => !prev.includes(id)),
        ]);

        console.log(newUids)
        console.log(newThreadIds)

    }

    function mailItemIsAThread(mailItem) {
        return !mailItem.internal && mailItem.threadSize > 1
    }


    function selectUnReadRecords() {
        const newUids = [];
        const newThreadIds = [];

        mailData.forEach((mail) => {
            if (mail.flags.includes("Recent")) {
                if (mailItemIsAThread(mail)) {
                    newThreadIds.push(mail.threadId);
                } else {
                    newUids.push(mail.uid);
                }
            }
        });

        setSelectedUids((prev) => [
            ...prev,
            ...newUids.filter((uid) => !prev.includes(uid)),
        ]);

        setSelectedThreadIds((prev) => [
            ...prev,
            ...newThreadIds.filter((id) => !prev.includes(id)),
        ]);
    }

    function handleStateUpdateSelectedRecord(id, checked) {
        if (typeof id === "number") {
            setSelectedUids(prev => {
                if (checked && !prev.includes(id)) {
                    return [...prev, id];
                }
                if (!checked) {
                    return prev.filter(item => item !== id);
                }
                return prev;
            });
        } else {
            setSelectedThreadIds(prev => {
                if (checked && !prev.includes(id)) {
                    return [...prev, id];
                }
                if (!checked) {
                    return prev.filter(item => item !== id);
                }
                return prev;
            });
        }

    }


    async function performMove(operation, from = "", to = "", uids = [], threadIds = []) {
        if (uids.length === 0 && from === "" && to === "" && threadIds.length === 0) {
            toast.error(`Please select a record to perform the operation.`, {containerId: TOAST_CONTAINER_ID})
            return
        }

        console.log(currentMbox)

        try {
            toast.loading(`Moving message(s).`, {containerId: TOAST_CONTAINER_ID})
            let resp = await moveMessageOnServer(StateManager.getToken(), {operation, from, uids, to, threadIds})
            await moveMessageInCache(resp)
            if (operation === "single") {
                if (isSingleMessageRender) {
                    setIsSingleMessageRender(false)
                    setCurrentMsg({})
                } else if (isThreadRendered) {
                    let threads = fullThread.filter(item => !uids.includes(item.uid))
                    setFullThread(threads)
                }
            }

            if (operation === "thread") {
                setIsThreadRendered(false)
                setFullThread([])
            }
            await renderListingAndBoxes()
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.success("Moving success", {containerId: TOAST_CONTAINER_ID})
        } catch (e) {
            console.error(e)
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.error("Error moving message(s)", {containerId: TOAST_CONTAINER_ID})
        }
    }

    async function markMessage(operation, box, flag, uids = [], threadIds = []) {
        console.log(`marking box: ${box}, flag: ${flag}`)
        if (uids.length === 0 && flag === "" && threadIds.length === 0) {
            toast.error(`Please select a record to perform the operation.`, {containerId: TOAST_CONTAINER_ID})
            return
        }

        try {
            toast.loading(`Marking message(s).`, {containerId: TOAST_CONTAINER_ID})
            await markMessageMainOperation(operation, box, flag, uids, threadIds)
            renderListing()
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            // toast.success("Marking success", {containerId: TOAST_CONTAINER_ID})
        } catch (e) {
            console.error(e)
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.error("Error marking message(s)", {containerId: TOAST_CONTAINER_ID})
        }
    }

    async function markMessageMainOperation(operation, box, flag, uids, threadIds = []) {
        let resp = await markMessageOnServer(StateManager.getToken(), {operation, box, flag, uids, threadIds})
        await markMessageInCache(resp)
        return renderListingAndBoxes()
    }

    async function performCopy(operation, from = "", to = "", uids = [], threadIds = []) {
        if (uids.length === 0 && from === "" && to === "" && threadIds.length === 0) {
            toast.error(`Please select a record to perform the operation.`, {containerId: TOAST_CONTAINER_ID})
            return
        }
        try {
            toast.loading(`Copying message(s).`, {containerId: TOAST_CONTAINER_ID})
            let resp = await copyMessageOnServer(StateManager.getToken(), {operation, from, to, uids, threadIds})
            await copyMessageInCache(resp)
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.success("Copy success.")
        } catch (e) {
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.error("Error copying message(s)", {containerId: TOAST_CONTAINER_ID})
        }
    }

    async function performDelete(operation, box = "", uids = [], threadIds = []) {
        if (uids.length === 0 && box === "" && threadIds.length === 0) {
            toast.error(`Please select a record to perform the operation.`, {containerId: TOAST_CONTAINER_ID})
            return
        }

        if (currentMbox !== TRASH_BOX) {
            return performMove(operation, box, TRASH_BOX, uids, threadIds)
        }

        setDeletePayload({
            operation,
            box,
            uids,
            threadIds,
        })

        setIsDeleteConfirmationOpen(true)
    }

    async function proceedWithDelete() {
        setIsDeleteConfirmationOpen(false)
        const {operation, threadIds, box, uids} = deletePayload
        try {
            toast.loading(`Deleting message(s)`, {containerId: TOAST_CONTAINER_ID})
            let resp = await deleteMessageOnServer(StateManager.getToken(), {operation, threadIds, box, uids})
            await deleteMessagesFromCache(resp)
            setIsSingleMessageRender(false)
            setCurrentMsg({})
            await renderListingAndBoxes()
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.success("Message delete success", {containerId: TOAST_CONTAINER_ID})
        } catch (e) {
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.error("Error deleting message(s)", {containerId: TOAST_CONTAINER_ID})
        }
    }


    const setIframeHeight = (iframe) => {
        if (!iframe) return;
        try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            if (iframeDoc && iframeDoc.body) {
                iframeDoc.body.style.overflowY = "hidden";
                const contentHeight = iframeDoc.body.scrollHeight + 20;
                iframe.style.height = contentHeight + "px";
            }
        } catch (e) {
            console.warn("Unable to access iframe content:", e);
        }
    };


    const [inputPage, setInputPage] = useState(currentPage);

    useEffect(() => {
        setInputPage(currentPage);
    }, [currentPage]);


    return (
        <>
            <Helmet>
                <title>Mail Page</title>
            </Helmet>
            <Header></Header>
            <div className="container-fluid">
                <div style={{overflow: "hidden", height: "95vh"}} className="row">
                    <div className="col-md-1 col-lg-1 col-xl-1 p-0">
                        <Navigation
                            ref={navigationRef}
                            socketCallbackFunction={renderListingAndBoxes}
                            isCallbackNeeded={isListingRenderNeeded}
                            handlerFunction={updateCache}
                            errorHandler={(e) => {
                                console.error(e)
                                StateManager.setIsCacheComplete(false)
                                StateManager.setIsCacheDbSetupComplete(false)
                            }}
                        />
                    </div>
                    <div className="col-md-1 col-lg-1 col-xl-1 p-0" style={{border: "1px solid grey"}}>

                        <select value={StateManager.getMailListingAccount()} onChange={changeAccount}
                                style={{width: "100%"}}>
                            {userAccounts.map((account) => (
                                <option key={account.value} value={account.value}>{account.text}</option>
                            ))}
                        </select>
                        <br></br>
                        <br></br>
                        <StandardButton customStyles={{height: "25px", width: "100%", padding: 0}}
                                        onClick={() => redirect("/boxes")} innerText={"Manage Folders"}/>
                        <br></br>
                        <br></br>
                        <ul style={{listStyleType: 'none'}} className="p-0">
                            {mailboxes.map((element) => {
                                return (<li key={element.name} id={element.name}
                                            className={element.name === currentMbox ? "highlighted mb-2 p-1" : "customLi mb-2 p-1"}
                                            style={{cursor: "pointer"}}
                                            onClick={() => stateUpdateCurrentMailbox(element.name)}>
                                    {createSubstring(element.name, 10)}{element.totalUnread > 0 && (<>&nbsp;&nbsp;&nbsp;
                                    <strong>({element.totalUnread})</strong></>)}
                                </li>)

                            })}
                        </ul>
                    </div>

                    <div className="col-md-3 col-lg-3 col-xl-3 p-0" style={{border: "1px solid grey"}}>
                        <StandardTextInput value={searchValue} onChange={handleSearchValue} disabled={cacheStarted}
                                           styles={{height: "2vh", width: "20vh"}}
                                           placeholder="Search here">
                        </StandardTextInput>&nbsp;
                        <button className={Styles.StandardButton} ref={searchButtonRef}
                                style={{paddingTop: 0, paddingBottom: 0}}
                                onClick={stateUpdateSearch}>Search
                        </button>
                        <StandardDropdown onChange={handleSelectionChange} selectedValue={selectionDropdownValue}
                                          customStyles={{"float": "right"}}
                                          options={[{value: "select", text: "Select"}, {
                                              value: "all",
                                              text: "All"
                                          }, {value: "unread", text: "Unread"}, {value: "clear", text: "Clear"}]}/>

                        <br></br>
                        <StandardDropdown onChange={stateUpdateSortOption}
                                          selectedValue={StateManager.getMailSortingKey()} name="Sort Option"
                                          options={sortOptions}></StandardDropdown>&nbsp;
                        <StandardDropdown onChange={stateUpdateSortOrder}
                                          selectedValue={StateManager.getMailSortingOrder()} name="Sort Order"
                                          options={sortOrders}></StandardDropdown><br></br>
                        <PaginationWithInput totalPages={totalPages} currentPage={currentPage}
                                             onPageChange={(e) => {
                                                 setCurrentPage(e)
                                             }}/>
                        <br></br>
                        <ul id="mail-list" className="p-0" style={{listStyle: "none", width: "100%"}}>
                            {mailData.map((mailItem, key) => (
                                <li style={{
                                    backgroundColor: renderedRecordUid === mailItem.uid ? 'lightgrey' : 'transparent',
                                    cursor: 'pointer',
                                }} key={mailItem.uid} id={mailItem.uid} onClick={() => renderMessage(key)}
                                    className="mb-2 mailListLi">
                                    <div className={Styles.mailListItem}
                                         style={{display: "flex", alignItems: "center"}}>
                                        {/* Yellow Dot for Unread */}
                                        {mailItem.flags && mailItem.flags.includes("Recent") && (
                                            <span style={{
                                                height: "8px",
                                                width: "8px",
                                                backgroundColor: "#FF8C00",
                                                borderRadius: "50%",
                                                display: "inline-block",
                                                marginRight: "8px"
                                            }}></span>
                                        )}

                                        {/* Email details */}
                                        <div>
                                    <span>
                                        <strong>Subject:</strong> {createSubstring(mailItem.decryptedSubject, 30)}
                                            </span>
                                            <br/>
                                            <span><strong>From:</strong> {createSubstring(decodeIfMimeEncoded(mailItem.from), 30)}</span>
                                            <br/>
                                            <span><strong>On:</strong> {mailItem.formattedDate}</span>
                                        </div>

                                        <div style={{marginLeft: "auto", display: "flex", alignItems: "center"}}>
                                            {(mailItemIsAThread(mailItem)) && (
                                                <>
                                                    <span style={{marginRight: "8px"}}>
                                                        <i className="fas fa-reply fa-xs" aria-hidden="true"></i>
                                                    </span>
                                                    <span style={{fontSize: "12px", color: "grey"}}>
                                                        ({countThreadSize(mailItem)})
                                                    </span>
                                                </>
                                            )}&nbsp;&nbsp;&nbsp;{selectionEnabled && (
                                            <input
                                                checked={mailItemIsAThread(mailItem)
                                                    ? selectedThreadIds.includes(mailItem.threadId)
                                                    : selectedUids.includes(mailItem.uid)
                                                }
                                                onClick={(e) => e.stopPropagation()}
                                                onChange={(e) => {
                                                    const id = mailItemIsAThread(mailItem) ? mailItem.threadId : mailItem.uid;
                                                    handleStateUpdateSelectedRecord(id, e.target.checked);
                                                }}
                                                type="checkbox"
                                            />)}
                                        </div>
                                    </div>
                                </li>
                            ))}
                            {mailData.length === 0 && (<span>Nothing to show</span>)}
                        </ul>
                    </div>

                    {/* Email Content Section */}
                    <div style={{maxHeight: "90vh", overflowY: "scroll"}} className="col-md-7 col-lg-7 col-xl-7">

                        {((selectionEnabled && (selectedUids.length > 0 || selectedThreadIds.length > 0)) || isThreadRendered) && (<>
                                <br></br>
                                <div
                                    style={{display: "flex", justifyContent: 'space-between', margin: '0 auto'}}
                                    className="icon-list">
                                    {(selectionEnabled && (selectedUids.length > 0 || selectedThreadIds.length > 0)) && (<>
                                        {/*<StandardIconDropDown*/}
                                        {/*    onSelect={(to) => performCopy("bulk", currentMbox, to, selectedUids, selectedThreadIds)}*/}
                                        {/*    label={"Copy Selected"}*/}
                                        {/*    iconClass="fa fa-copy"*/}
                                        {/*    options={dropDownBoxes}*/}
                                        {/*/>*/}


                                        <StandardIconDropDown
                                            onSelect={(value) => markMessage("bulk", currentMbox, value, selectedUids, selectedThreadIds)}
                                            label={"Mark Selected As"}
                                            iconClass="fa fa-copy"
                                            options={dropDownReadUnread}
                                        />

                                        <StandardIconDropDown
                                            onSelect={(to) => performMove("bulk", currentMbox, to, selectedUids, selectedThreadIds)}
                                            label={"Move Selected"}
                                            iconClass="fa fa-arrow-right-arrow-left"
                                            options={dropDownBoxes}
                                        />

                                        <div
                                            onClick={() => performDelete("bulk", currentMbox, selectedUids, selectedThreadIds)}
                                            className={Styles.iconItem}>
                                            <i style={{cursor: "pointer"}} className="fa fa-xmark-circle"></i>
                                            <p style={{cursor: "pointer"}}>Delete Selected</p>
                                        </div>
                                    </>)}
                                    {isThreadRendered && (<>
                                        {/*<StandardIconDropDown*/}
                                        {/*    onSelect={(to) => performCopy("thread", currentMsg.box, to, [], [currentMsg.threadId])}*/}
                                        {/*    label={"Copy Thread"}*/}
                                        {/*    iconClass="fa fa-copy"*/}
                                        {/*    options={dropDownBoxes}*/}
                                        {/*/>*/}

                                        <StandardIconDropDown
                                            onSelect={(value) => markMessage("thread", fullThread[0].box, value, [], [fullThread[0].threadId])}
                                            label={"Mark Thread As"}
                                            iconClass="fa fa-copy"
                                            options={dropDownReadUnread}
                                        />

                                        <StandardIconDropDown
                                            onSelect={(to) => performMove("thread", fullThread[0].box, to, [], [fullThread[0].threadId])}
                                            label={"Move Thread"}
                                            iconClass="fa fa-arrow-right-arrow-left"
                                            options={dropDownBoxes}
                                        />

                                        <div
                                            onClick={() => performDelete("thread", fullThread[0].box, [], [fullThread[0].threadId])}
                                            className={Styles.iconItem}>
                                            <i style={{cursor: "pointer"}} className="fa fa-xmark-circle"></i>
                                            <p style={{cursor: "pointer"}}>Delete Thread</p>
                                        </div>
                                    </>)}
                                </div>
                            </>
                        )}

                        {isThreadRendered && (
                            <>
                                {fullThread.map((currentMsg, key) => (
                                    <React.Fragment key={key}>
                                        <div onClick={() => toggleMessageExpansion(key)}
                                             id={currentMsg.messageId + "-header"}
                                             style={{
                                                 marginTop: "10px",
                                                 width: "100%",
                                                 border: "1px solid grey",
                                                 height: "30px"
                                             }}>
                                            <span><strong>On:</strong></span>&nbsp;
                                            <span>{currentMsg.formattedDate}</span>
                                            <div style={{
                                                height: "100%",
                                                marginRight: "5px",
                                                float: "right",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "20px"
                                            }}>
                                                {currentMsg.parsedAttachmentNames.length > 0 && (<span><i
                                                    className="fas fa-paperclip"></i>{currentMsg.parsedAttachmentNames.length}</span>)}
                                                <span><i
                                                    className={extractEmail(currentMsg.from) === StateManager.getUserEmail() ? "fa fa-arrow-up" : "fa fa-arrow-down"}></i>&nbsp;&nbsp;{fullThread.length - key}</span><br/><br/>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: expandedMessages.includes(key) ? "block" : "none",
                                                justifyContent: 'space-between',
                                                width: "100%",
                                                margin: '0 auto'
                                            }}
                                            id={`message-content-${key}`}
                                            className="col-md-7 col-lg-7 col-xl-7"
                                        >
                                            <br/>
                                            <div style={{
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: 'space-between'
                                            }} className="icon-list">
                                                <div onClick={() => reply(currentMsg)}
                                                     className={Styles.iconItem}>
                                                    <i style={{cursor: "pointer"}} className="fa fa-reply"></i>
                                                    <p style={{cursor: "pointer"}}>Reply</p>
                                                </div>
                                                <div onClick={() => replyAll(currentMsg)}
                                                     className={Styles.iconItem}>
                                                    <i style={{cursor: "pointer"}}
                                                       className="fa fa-reply-all"></i>
                                                    <p style={{cursor: "pointer"}}>Reply All</p>
                                                </div>
                                                <div onClick={() => forward(currentMsg)}
                                                     className={Styles.iconItem}>
                                                    <i style={{cursor: "pointer"}} className="fa fa-share"></i>
                                                    <p style={{cursor: "pointer"}}>Forward</p>
                                                </div>

                                                {/*<StandardIconDropDown*/}
                                                {/*    onSelect={(to) => performCopy("single", currentMsg.box, to, [currentMsg.uid], [])}*/}
                                                {/*    label={"Copy"}*/}
                                                {/*    iconClass="fa fa-copy"*/}
                                                {/*    options={dropDownBoxes}*/}
                                                {/*/>*/}

                                                <StandardIconDropDown
                                                    onSelect={(value) => markMessage("single", currentMsg.box, value, [currentMsg.uid], [])}
                                                    label={"Mark This As"}
                                                    iconClass="fa fa-copy"
                                                    options={dropDownReadUnread}
                                                />

                                                <StandardIconDropDown
                                                    onSelect={(to) => performMove("single", currentMsg.box, to, [currentMsg.uid], [])}
                                                    label={"Move"}
                                                    iconClass="fa fa-arrow-right-arrow-left"
                                                    options={dropDownBoxes}
                                                />

                                                <div
                                                    onClick={() => performDelete("single", currentMsg.box, [currentMsg.uid], [])}
                                                    className={Styles.iconItem}>
                                                    <i style={{cursor: "pointer"}} className="fa fa-xmark-circle"></i>
                                                    <p style={{cursor: "pointer"}}>Delete</p>
                                                </div>
                                            </div>

                                            <br></br>
                                            <div
                                                style={{width: "100%"}}
                                                className="message-render-headers-section"
                                            >
                                                <StandardButton
                                                    onClick={() => showHeaders(currentMsg.uid)}
                                                    innerText={"Headers"}
                                                    customStyles={{
                                                        width: "75px",
                                                        height: "30px",
                                                        padding: 0,
                                                        backgroundColor: "#9fa19f"
                                                    }}
                                                />
                                                <br/><br/>
                                                <span><strong>From</strong>: {decodeIfMimeEncoded(currentMsg.from)}</span><br/>
                                                <span><strong>To</strong>: {currentMsg.to}</span><br/>
                                                <span><strong>CC:</strong> {currentMsg.cc}</span><br/>
                                                <span><strong>On:</strong> {currentMsg.formattedDate}</span><br/>
                                                <span><strong>Subject:</strong> {currentMsg.decryptedSubject}</span><br/>
                                            </div>

                                            <br/>
                                            <div
                                                id="attachment-names"
                                                style={{display: "flex", flexWrap: "wrap", gap: "5px", width: "100%"}}
                                                className="attachment-names"
                                            >

                                                {!_.isEmpty(currentMsg.parsedAttachmentNames) && (<>

                                                    {currentMsg.parsedAttachmentNames.map((item) => (

                                                        <div
                                                            onClick={() => downloadAttachment(item, currentMsg.box, currentMsg.uid, currentMsg.isEncrypted)}
                                                            key={currentMbox.messageId + "-" + item}
                                                            style={{
                                                                flex: "1 0 150px",
                                                                backgroundColor: "#f0f0f0",
                                                                textAlign: "center",
                                                                border: "1px solid #ccc",
                                                                boxSizing: "border-box"
                                                            }}>
                                                            {item}
                                                        </div>

                                                    ))}


                                                </>)}


                                            </div>

                                            <br/>
                                            <iframe
                                                ref={(el) => setIframeHeight(el)}
                                                onLoad={(e) => setIframeHeight(e.target)}
                                                key={`message-frame-${currentMsg.messageId}`}
                                                srcDoc={currentMsg.decryptedBody}
                                                title={"message-frame-" + currentMsg.messageId}
                                                style={{
                                                    width: "100%",
                                                    display: "block",
                                                    height: "auto",
                                                    border: "none"
                                                }}
                                            ></iframe>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </>
                        )}

                        {isSingleMessageRender && (
                            <React.Fragment>
                                <br/>
                                <div
                                    style={{display: "flex", justifyContent: 'space-between', margin: '0 auto'}}
                                    className="icon-list"
                                >
                                    <div onClick={() => reply(currentMsg)} className={Styles.iconItem}>
                                        <i style={{cursor: "pointer"}} className="fa fa-reply"></i>
                                        <p style={{cursor: "pointer"}}>Reply</p>
                                    </div>
                                    <div onClick={() => replyAll(currentMsg)} className={Styles.iconItem}>
                                        <i style={{cursor: "pointer"}} className="fa fa-reply-all"></i>
                                        <p style={{cursor: "pointer"}}>Reply All</p>
                                    </div>
                                    <div onClick={() => forward(currentMsg)} className={Styles.iconItem}>
                                        <i style={{cursor: "pointer"}} className="fa fa-share"></i>
                                        <p style={{cursor: "pointer"}}>Forward</p>
                                    </div>

                                    {/*<StandardIconDropDown*/}
                                    {/*    onSelect={(to) => performCopy("single", currentMsg.box, to, [currentMsg.uid], [])}*/}
                                    {/*    label={"Copy"}*/}
                                    {/*    iconClass="fa fa-copy"*/}
                                    {/*    options={dropDownBoxes}*/}
                                    {/*/>*/}

                                    <StandardIconDropDown
                                        onSelect={(value) => markMessage("single", currentMsg.box, value, [currentMsg.uid], [])}
                                        label={"Mark This As"}
                                        iconClass="fa fa-copy"
                                        options={dropDownReadUnread}
                                    />

                                    <StandardIconDropDown
                                        onSelect={(to) => performMove("single", currentMsg.box, to, [currentMsg.uid], [])}
                                        label={"Move"}
                                        iconClass="fa fa-arrow-right-arrow-left"
                                        options={dropDownBoxes}
                                    />

                                    <div onClick={() => performDelete("single", currentMsg.box, [currentMsg.uid], [])}
                                         className={Styles.iconItem}>
                                        <i style={{cursor: "pointer"}} className="fa fa-xmark-circle"></i>
                                        <p style={{cursor: "pointer"}}>Delete</p>
                                    </div>
                                </div>

                                <br/>
                                <div className="message-render-headers-section">
                                    <StandardButton
                                        onClick={() => showHeaders(currentMsg.uid)}
                                        innerText={"Headers"}
                                        customStyles={{
                                            width: "75px",
                                            height: "30px",
                                            padding: 0,
                                            backgroundColor: "#9fa19f"
                                        }}
                                    />
                                    <br/><br/>
                                    <span><strong>From</strong>: {decodeIfMimeEncoded(currentMsg.from)}</span><br/>
                                    <span><strong>To</strong>: {currentMsg.to}</span><br/>
                                    <span><strong>CC:</strong> {currentMsg.cc}</span><br/>
                                    <span><strong>On:</strong> {currentMsg.formattedDate}</span><br/>
                                    <span><strong>Subject:</strong> {currentMsg.decryptedSubject}</span><br/>
                                </div>

                                <br/>
                                <div
                                    id="attachment-names"
                                    style={{display: "flex", flexWrap: "wrap", gap: "5px", width: "100%"}}
                                    className="attachment-names"
                                >

                                    {!_.isEmpty(currentMsg.parsedAttachmentNames) && (<>

                                        {currentMsg.parsedAttachmentNames.map((item) => (

                                            <div
                                                onClick={() => downloadAttachment(item, currentMsg.box, currentMsg.uid, currentMsg.isEncrypted)}
                                                key={currentMbox.messageId + "-" + item}
                                                style={{
                                                    flex: "1 0 150px",
                                                    backgroundColor: "#f0f0f0",
                                                    textAlign: "center",
                                                    border: "1px solid #ccc",
                                                    boxSizing: "border-box"
                                                }}>
                                                {item}
                                            </div>

                                        ))}


                                    </>)}

                                </div>

                                <br/>
                                <iframe
                                    ref={(el) => setIframeHeight(el)}
                                    onLoad={(e) => setIframeHeight(e.target)}
                                    title={`message-frame-${currentMsg.messageId}`}
                                    key={`message-frame-${currentMsg.messageId}`}
                                    srcDoc={currentMsg.decryptedBody}
                                    style={{
                                        width: "100%",
                                        border: "bottom 1px solid",
                                        overflow: "hidden",
                                        display: "block"
                                    }}
                                    scrolling="no"
                                />
                            </React.Fragment>
                        )}

                    </div>


                    <Modal
                        style={headerModalStyles}
                        isOpen={isModalOpen}
                        onRequestClose={closeHeaders}
                        ariaHideApp={false}
                    >
                        <button
                            onClick={closeHeaders}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'transparent',
                                border: 'none',
                                fontSize: '1.5rem',
                                cursor: 'pointer',
                            }}
                            aria-label="Close modal"
                        >
                            &times;
                        </button>
                        <br></br><br></br>
                        <p>{modalContent}</p>
                    </Modal>

                    <Modal
                        style={deleteConfirmationStyles}
                        isOpen={isDeleteConfirmationOpen}
                        onRequestClose={closeDeleteConfirmationModal}
                        ariaHideApp={false}
                    >
                        <h4>Confirm Delete</h4><b></b>
                        <span>Message(s) will be permanently deleted. Are you sure ?</span><br></br><br></br>
                        <div style={{float: "right", display: "flex"}}>
                            <button
                                style={{color: "white", float: "right", marginRight: "20px", backgroundColor: "green"}}
                                onClick={closeDeleteConfirmationModal}>Cancel
                            </button>
                            <button onClick={proceedWithDelete}
                                    style={{color: "white", float: "right", backgroundColor: "red"}}>Delete
                            </button>
                        </div>
                    </Modal>

                </div>
            </div>
            <ToastContainer containerId={TOAST_CONTAINER_ID}/>
        </>
    );
}